import type { HeroBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface HeroBlockEditorProps {
  content: HeroBlockContent | null
  onChange: (content: HeroBlockContent) => void
}

export function HeroBlockEditor({ content, onChange }: HeroBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<HeroBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Hero</h3>
        <p className="text-sm text-muted-foreground">
          Headline and CTA. Organization name comes from your profile.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Headline</Label>
          <Input
            value={c.headline ?? ""}
            onChange={(e) => update({ headline: e.target.value })}
            placeholder="Your impact starts here"
          />
        </div>
        <div>
          <Label>Subheadline / Tagline</Label>
          <Input
            value={c.subheadline ?? ""}
            onChange={(e) => update({ subheadline: e.target.value })}
            placeholder="Empowering communities through sustainable solutions."
          />
        </div>
        <div>
          <Label>Button text</Label>
          <Input
            value={c.cta_text ?? "Donate now"}
            onChange={(e) => update({ cta_text: e.target.value })}
            placeholder="Donate now"
          />
        </div>
        <div>
          <Label>Background image URL (optional)</Label>
          <Input
            value={c.background_image ?? ""}
            onChange={(e) => update({ background_image: e.target.value || undefined })}
            placeholder="https://..."
          />
        </div>
      </CardContent>
    </Card>
  )
}
